import axios from './axios';

const AmenityService = {
  getAmenities: () => axios.get('/api/v1/amenities'),
  getAmenity: (id) => axios.get(`/api/v1/amenities/${id}`),
  createAmenity: (data) => axios.post('/api/v1/amenities', data),
  updateAmenity: (id, data) => axios.put(`/api/v1/amenities/${id}`, data),
  deleteAmenity: (id) => axios.delete(`/api/v1/amenities/${id}`),
  
  getMetrics: () => axios.get('/api/v1/amenities/metrics'),
  getUnits: () => axios.get('/api/v1/units'),

  getBookings: () => axios.get('/api/v1/amenity-bookings'),
  createBooking: (data) => axios.post('/api/v1/amenity-bookings', data),
  updateBooking: (id, data) => axios.put(`/api/v1/amenity-bookings/${id}`, data),
  deleteBooking: (id) => axios.delete(`/api/v1/amenity-bookings/${id}`),
  approveBooking: (id) => axios.patch(`/api/v1/amenity-bookings/${id}/approve`),
  rejectBooking: (id) => axios.patch(`/api/v1/amenity-bookings/${id}/reject`),
  downloadReceipt: (id) => axios.get(`/api/v1/amenity-bookings/${id}/receipt`, { responseType: 'blob' }),

  // Reporting Endpoints
  getReportBookings: (params) => axios.get('/api/v1/amenities/reports/bookings', { params }),
  getReportRevenue: (params) => axios.get('/api/v1/amenities/reports/revenue', { params }),
  getReportUtilisation: (params) => axios.get('/api/v1/amenities/reports/utilisation', { params }),
};

export default AmenityService;
